import { useCallback } from 'react'

import { fileSize } from '@bettermode/common/filesize'
import { File } from '@tribeplatform/gql-client/types'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { FileTypeIcon } from '../../../common/components/FileTypeIcon/FileTypeIcon.js'
import { useMediaModal } from '../../../MediaModal/MediaModalProvider.js'

interface Props {
  attachment: File
}

export const MessageAttachment = ({ attachment }: Props) => {
  const { openSlideWithIndex, slidesRef } = useMediaModal()

  const onAttachmentClick = useCallback(() => {
    const idx = slidesRef.current.findIndex(a => a.id === attachment.id)
    openSlideWithIndex(idx)
  }, [slidesRef, openSlideWithIndex, attachment])

  return (
    <div
      className="flex items-center gap-2 text-content group w-full bg-surface-subdued p-3 rounded-lg cursor-pointer"
      onClick={onAttachmentClick}
    >
      <FileTypeIcon
        extension={attachment.extension}
        className="w-[40px] h-[40px]"
      />
      <div className="flex items-center gap-3 justify-between truncate w-full">
        <div className="truncate min-w-0 flex-1 grow">
          <div className="truncate">{attachment.name}</div>
          <div className="text-start text-xs">{fileSize(attachment.size)}</div>
        </div>
        <div className="flex items-center gap-2">
          <IconButton
            as="a"
            onClick={e => e.stopPropagation()}
            href={attachment.downloadUrl}
            target="_blank"
            variant="tertiaryNeutral"
            icon={<SvgIcon name="download" />}
            className="shrink-0 "
          />
        </div>
      </div>
    </div>
  )
}
